module.exports = __webpack_public_path__ + "img/1.96557bba.jpg";